<template>
  <div class="container-adicionar-pessoa" @click="adicionarPaciente">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
          <v-icon size="60" v-on="on" color="#213848">mdi-plus-circle-outline</v-icon>
      </template>
      Adicionar paciente
    </v-tooltip>
  </div>
</template>

<script>


export default {
    name: 'AdicionarPacienteEsperaCard',
    methods: {
        adicionarPaciente(){
            this.$emit('adicionarPaciente')
        },
    }
}
</script>


<style scoped lang="stylus">

.container-adicionar-pessoa
  border 2px solid #213848
  border-radius 5px
  display flex
  justify-content center
  align-items center
  height 126px

.container-adicionar-pessoa:hover
  cursor pointer
  border-color white
  .v-icon
    color white !important

</style>